import { EmailSettingsManager } from "./EmailSettingsManager";
import EmailForwardingManager from "./EmailForwardingManager";

export default function EmailSettingsPage() {
  return (
    <div className="space-y-6">
      <EmailSettingsManager />
      <EmailForwardingManager />
    </div>
  );
}